import { differenceInSeconds, isSameDay } from 'date-fns'
import React, {
  FC,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import Scrollbar from 'react-scrollbars-custom'
import { ChatContext } from '~/service/chatConn'
import {
  Message,
  MessageInfo,
  MessageTyping,
  MessageUnread,
} from '~/service/chatConn/types'
import { formatDate } from '~/utils/dateFns'
import Messages from './Messages'
import useResizeObserver from 'use-resize-observer'

const UID_TYPING = 'typing'

type OutputProps = {
  // checkScroll: (el: HTMLDivElement) => void
}

const Output: FC<OutputProps> = ({}) => {
  const {
    activeChat: { messages, history, clientTyping: typing, unreadAt },
  } = useContext(ChatContext)
  const historyMessages = useMemo(
    () => history.flatMap(chat => chat.parts.flatMap(part => part.messages)),
    []
  )
  const isAnimatingRef = useRef(false)
  const [visibleCounter, setVisibleCounter] = useState(0)
  const [outputScroll, setOutputScroll] = useState(1)

  const ref = useRef<HTMLDivElement | null>(null)
  const { height = 0 } = useResizeObserver<HTMLDivElement>({ ref })

  const typingIdRef = useRef(0)

  // useEffect(() => {
  //   ref.current && checkScroll(ref.current)
  // }, [])

  const scrollToBottom = () => {
    // react 18 fix
    // jeśli nie ma timeouta, to scrollHeight jest mniejszy
    setTimeout(() => {
      if (!ref.current) {
        return
      }

      const { offsetHeight, scrollHeight } = ref.current

      const lastMsg = ref.current.children[0].children[
        ref.current.children[0].children.length - 1
      ] as HTMLDivElement

      const lastMsgOffset = lastMsg.offsetHeight - offsetHeight

      const lastMsgOverflowFix = lastMsgOffset > 0 ? lastMsgOffset + 15 : 0

      ref.current.scrollTop = scrollHeight - offsetHeight - lastMsgOverflowFix
    })
  }

  useEffect(scrollToBottom, [])

  useEffect(() => {
    window.addEventListener('visibilitychange', () => {
      if (!document.hidden && isAnimatingRef.current) {
        setVisibleCounter(i => i + 1)

        setTimeout(() => {
          scrollToBottom()
        })
      }
    })
  }, [])

  //

  const finalMessages = addCustomMessages(
    messages,
    typing,
    typingIdRef,
    historyMessages,
    unreadAt
  )

  return (
    // <Scrollbar
    //   className="chat-output"
    //   elementRef={r => (ref.current = r)}
    //   disableTracksWidthCompensation={true}
    //   // onScroll={() => ref.current && checkScroll(ref.current)}
    // >
    //   <Messages messages={localMessages} scrollToBottom={scrollToBottom} />
    // </Scrollbar>

    <div
      className="chat-output"
      ref={ref}
      onScroll={() => ref.current && setOutputScroll(ref.current.scrollTop)}
    >
      <Messages
        isAnimatingRef={isAnimatingRef}
        messages={finalMessages}
        scrollToBottom={scrollToBottom}
        key={visibleCounter}
        outputScroll={outputScroll}
        height={height}
        outputRef={ref}
      />
    </div>
  )
}

const addCustomMessages = (
  messages: Message[],
  typing: boolean,
  typingIdRef: React.MutableRefObject<number>,
  historyMessages: Message[],
  unreadAt: string | undefined
) => {
  let localMessages = [...historyMessages, ...messages]

  localMessages = localMessages.reduce((messages, message, i) => {
    const timeMsg = (withDate: boolean): MessageInfo => ({
      ...message,
      type: 'INFO',
      uid: 'time' + message.uid,
      content: formatDate(message.sentAt, withDate ? 'PPp' : 'p'),
    })

    if (i > 0) {
      const date = message.sentAt
      const prevDate = localMessages[i - 1].sentAt

      return differenceInSeconds(date, prevDate) > 60 * 5
        ? [...messages, timeMsg(!isSameDay(date, prevDate)), message]
        : [...messages, message]
    } else {
      return [timeMsg(!!historyMessages.length), message]
    }
  }, [] as Message[])

  localMessages = localMessages.reduce((messages, message, i) => {
    const unreadMsg = (): MessageUnread => ({
      ...message,
      type: 'UNREAD',
      uid: 'unread',
    })

    return unreadAt == message.uid
      ? [...messages, unreadMsg(), message]
      : [...messages, message]
  }, [] as Message[])

  useEffect(() => {
    if (!typing) {
      typingIdRef.current++
    }
  }, [typing])

  if (typing) {
    const typingMsg: MessageTyping = {
      type: 'TYPING',
      uid: UID_TYPING + typingIdRef.current,
      content: '',
      queueId: 0,
      sentAt: new Date(),
      unread: false,
    }

    localMessages = [...localMessages, typingMsg]
  }

  return localMessages
}

export default Output
